import React from 'react';
import styles from './UIGameBarbarianInvasionTracker.module.scss';
import clsx from 'clsx';
import { UIGameBarbarianInvasionTrackerHex } from './UIGameBarbarianInvasionTrackerHex/index.ts';
import { UIGameBarbarianInvasionTrackerShip } from './UIGameBarbarianInvasionTrackerShip/index.ts';
import { UIGameBarbarianInvasionTrackerKnight } from './UIGameBarbarianInvasionTrackerKnight/index.ts';
const getHexType = (idx, barbarianProgress, progressWhenBarbariansAttack)=>{
    if (idx === progressWhenBarbariansAttack) return 'attack';
    if (idx === barbarianProgress) return 'active';
    return 'inactive';
};
export const UIGameBarbarianInvasionTracker = ({ knightStrength, barbarianStrength, className, barbarianProgress, progressWhenBarbariansAttack })=>{
    const arePlayersWinning = knightStrength >= barbarianStrength;
    const trackerPositionX = barbarianProgress % 2 === 0 ? 0 : 23;
    const trackerPositionY = barbarianProgress * 80;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, Array.from({
        length: progressWhenBarbariansAttack + 1
    }).map((_, idx)=>/*#__PURE__*/ React.createElement(UIGameBarbarianInvasionTrackerHex, {
            className: styles.hexIcon,
            key: idx,
            type: getHexType(idx, barbarianProgress, progressWhenBarbariansAttack)
        })), /*#__PURE__*/ React.createElement("div", {
        className: styles.barbarianIcons,
        style: {
            transform: `translate(${trackerPositionX}%,${trackerPositionY}%)`
        }
    }, /*#__PURE__*/ React.createElement(UIGameBarbarianInvasionTrackerShip, {
        barbarianStrength: barbarianStrength
    }), /*#__PURE__*/ React.createElement(UIGameBarbarianInvasionTrackerKnight, {
        arePlayersWinning: arePlayersWinning,
        knightStrength: knightStrength
    })));
};
